import { GraphQLInt, GraphQLString, GraphQLBoolean } from 'graphql';
import { mutationWithClientMutationId } from 'graphql-relay';
import uuid from 'uuid';
import AssetTypeEnum from 'appConsts/AssetType';

import getFieldsFromOffer from 'helper/LearningSpaceServices/TransformationHelpers/getFieldsFromOffer';
import getFieldOneCard from 'helper/LearningSpaceServices/TransformationHelpers/getFieldOneCard';
import getCardFromOffer from 'helper/LearningSpaceServices/TransformationHelpers/getCardFromOffer';
import { getContentDetailsByContentId } from 'helper/LearningSpaceServices/LocalStore';
import User from 'helper/currentUser';
import { CommandTypeEnum } from 'appConsts';

import mutationSync from '../helpers/mutationSync';
import CardPerformance from '../gqlTypes/cardPerformance.gql';
import CoursePerformance from '../gqlTypes/coursePerformance.gql';
import CourseType from '../gqlTypes/course.gql';

const user = new User();

module.exports = mutationWithClientMutationId({
  name: 'UpdateBlockPerformance',
  inputFields: {
    courseId: {
      type: GraphQLString
    },
    cardId: {
      type: GraphQLString
    },
    time: {
      type: GraphQLInt
    },
    userId: {
      type: GraphQLString
    },
    timeStamp: {
      type: GraphQLString
    },
    blockPerformance: {
      type: GraphQLString
    }
  },
  outputFields: {
    success: {
      type: GraphQLBoolean
    },
    cardPerformance: {
      type: CardPerformance
    },
    coursePerformance: {
      type: CoursePerformance
    },
    course: {
      type: CourseType
    }
  },
  mutateAndGetPayload: params => new Promise(async (resolve) => {
    try {
      const { cardId: contentId, userId, courseId, blockPerformance } = params;

      const command = {
        id: uuid(),
        type: CommandTypeEnum.UPDATE_BLOCK_PERFORMANCE,
        contentId,
        userId,
        creatorId: userId,
        blockPerformance,
        timeStamp: new Date().toISOString(),
        rootContentId: courseId
      };

      const { offer, updatedStates, stateInteractions } = await mutationSync({
        offerId: courseId,
        offerType: AssetTypeEnum.offer,
        userObject: {
          userId,
          companyId: user.companyId()
        },
        command
      });

      const coursePerformance = getFieldsFromOffer(offer, updatedStates).coursePerformance;
      const contentDetails = await getContentDetailsByContentId(courseId);
      const cardPerformance = getFieldOneCard(
        offer,
        contentDetails,
        getCardFromOffer(contentId, offer),
        updatedStates,
        stateInteractions
      ).performance;
      const course = getFieldsFromOffer(offer, updatedStates);

      resolve({ success: true, coursePerformance, cardPerformance, course });
    } catch (error) {
      console.error('error in UpdateBlockPerformanceMutation:', error);
      window.bugsnagClient && window.bugsnagClient.notify(error);
    }
  })
});
